(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('orderPackagesTable', function (SplashModalService, ModalService) {
		return {
			scope: {
				packages: '='
			},
			templateUrl: 'directives/orderPackagesTable/table.html',
			controller: function($scope, $uibModal) {

                $scope.restoreItem = function(thePackage, idx){

                    let scope = $scope; // need this inside the controller for the modal

                    let modalInstance = $uibModal.open({
                        animation: true,
                        windowClass: 'topmost',
                        backdropClass: 'topmost',
                        template: `
                            <div class="modal-header">
                                <h3 class="modal-title">Restore this item to the order?</h3>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                                <button class="btn btn-success" type="button" ng-click="restore()">Restore</button>
                            </div>`,
                        controller: function($scope, $uibModalInstance, idx) {

                            $scope.restore = function () {

                                scope.products[idx].deleted = false;

                                scope.save();

                                $uibModalInstance.close(idx);
                            };

                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                        },
                        resolve: {
                            idx: function() {
                                return idx;
                            }
                        },
                        size: 'sm'
                    });

                };

                $scope.removeItem = function(thePackage, idx) {

                    console.log('idx:',idx);
                    console.log('thePackage', thePackage);

                    return;

                    let scope = $scope; // need this inside the controller for the modal

                    console.log('scope', scope);

                    let modalInstance = $uibModal.open({
                        animation: true,
                        windowClass: 'topmost',
                        backdropClass: 'topmost',
                        template: `
                            <div class="modal-header">
                                <h3 class="modal-title">Remove this item from the order?</h3>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                                <button class="btn btn-danger" type="button" ng-click="delete()">Delete</button>
                            </div>`,
                        controller: function($scope, $uibModalInstance, idx) {

                            $scope.delete = function () {

                                scope.products[idx].deleted = true;

                                scope.save();

                                $uibModalInstance.close(idx);
                            };

                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                        },
                        resolve: {
                            idx: function() {
                                return idx;
                            }
                        },
                        size: 'sm'
                    });

                };

                $scope.editItem = function(item) {

                    var modalInstance = $uibModal.open({
                        size: 'lg',
                        animation: true,
                        templateUrl: 'directives/orderDetail/editOrderItem.html',
                        windowClass: 'edit_order_item_modal topmost',
                        backdropClass: 'topmost',
                        controller: function($scope, $uibModalInstance) {
                          $scope.itemTotal = 0;
                          $scope.itemCount = 0;
                          $scope.selections = {};
                          $scope.item = item;

                          $scope.propertyEditorRowSave = function () {

                              scope.save();

                          };

                          $scope.close = function () {
                              $uibModalInstance.dismiss('cancel');
                          };
                        }
                    });
                };


                $scope.editPackage = function(item) {
                    console.log('editPackage', item);
                    console.log('editPackage outside scope', $scope);

                    var parent = $scope.$parent;

                    var modalInstance = $uibModal.open({
                        size: 'lg',
                        animation: true,
                        templateUrl: 'directives/orderDetail/editOrderPackage.html',
                        windowClass: 'edit_order_item_modal',
                        controller: function($scope, $uibModalInstance) {

                            $scope.propertyEditorRowSave = function () {

                                parent.save();

                            };

                            $scope.item = item;

                            $scope.close = function () {
                                $uibModalInstance.dismiss('cancel');
                            };
                      }
                    });
                };

                $scope.restorePackage = function(thePackage){

                    let scope = $scope; // need this inside the controller for the modal

                    let modalInstance = $uibModal.open({
                        animation: true,
                        windowClass: 'topmost',
                        backdropClass: 'topmost',
                        template: `
                            <div class="modal-header">
                                <h3 class="modal-title">Restore this item to the order?</h3>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                                <button class="btn btn-success" type="button" ng-click="restore()">Restore</button>
                            </div>`,
                        controller: function($scope, $uibModalInstance) {

                            $scope.restore = function () {

                                thePackage.deleted = false;

                                scope.$parent.save();

                                $uibModalInstance.close();
                            };

                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                        },
                        size: 'sm'
                    });

                };

                $scope.removePackage = function(thePackage) {

                    console.log('thePackage', thePackage);

                    let scope = $scope; // need this inside the controller for the modal

                    console.log('scope', scope);

                    let modalInstance = $uibModal.open({
                        animation: true,
                        windowClass: 'topmost',
                        backdropClass: 'topmost',
                        template: `
                            <div class="modal-header">
                                <h3 class="modal-title">Remove this package from the order?</h3>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                                <button class="btn btn-danger" type="button" ng-click="delete()">Delete</button>
                            </div>`,
                        controller: function($scope, $uibModalInstance) {

                            $scope.delete = function () {

                                thePackage.deleted = true;

                                scope.$parent.save();

                                $uibModalInstance.close();
                            };

                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                        },
                        size: 'sm'
                    });

                };


                // I don't think I need this, I'm not sure. ~ Oct  8, 2017
                // $scope.$watch('packages', _.debounce(function(newValue, oldValue) {
                //     if (newValue !== oldValue)
                //         $scope.order.$save();
                // }), 500);

			}
		};
	});

})();
